'use strict'

/**
 * Internal cross-file primitives for the upstreamMasterLot/ cluster.
 *
 * Consumers should reach for the package barrel
 * (`@/util/refinery/upstream/upstreamMasterLot`); this helper is deliberately
 * not re-exported as public surface.
 */

export const toFinite = (value) => (Number.isFinite(value) ? value : 0)
